import { Serializable } from '@admin/core/models/serializable';
import { RoleEnum } from '@admin/shared/models/role-enum';

export class AdminSubmitDataModel
  implements Serializable<AdminSubmitDataModel>
{
  fromObject(object: any): AdminSubmitDataModel {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    return {
      AdminId: this.adminId,
      FullName: this.fullName,
      Email: this.email,
      MobileNumber: this.mobileNumber,
      Phone: this.phoneNumber,
      PhoneExtension: this.phoneExtension,
      Username: this.username,
      Password: this.password,
      Position: this.position,
      Permissions: this.permissions,
      RoleId: this.roleId,
    };
  }

  public adminId: number;
  public fullName: string;
  public position: string;
  public email: string;
  public mobileNumber: string;
  public phoneNumber: string;
  public phoneExtension: string;
  public username: string;
  public password: string;
  public permissions: number[];
  public roleId: number;

  constructor() {
    this.permissions = [];
  }
}
